import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum BankAccountsFormErrorStatesEnum {
    UploadStatementFailed = ErrorStateScheduleEnum.BankAccountsFormStatesStartIndex,
    CreateBankAccountFailed,
    GetBankAccountFailed,
    UpdateBankAccountFailed,
    DeleteBankAccountRestricted
}
